import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

// Async thunks
export const fetchBillingStatements = createAsyncThunk(
  "billingStatement/fetchAll",
  async (params) => {
    const response = await axios.get(`${API_URL}/billing-statement`, {
      params,
    });
    return response.data;
  },
);

export const fetchBillingStatement = createAsyncThunk(
  "billingStatement/fetchOne",
  async (id) => {
    const response = await axios.get(`${API_URL}/billing-statement/${id}`);
    return response.data;
  },
);

export const createBillingStatement = createAsyncThunk(
  "billingStatement/create",
  async (data) => {
    const response = await axios.post(`${API_URL}/billing-statement`, data);
    return response.data;
  },
);

export const sendBillingStatement = createAsyncThunk(
  "billingStatement/send",
  async (id) => {
    const response = await axios.post(
      `${API_URL}/billing-statement/${id}/send`,
    );
    return response.data;
  },
);

export const recordPayment = createAsyncThunk(
  "billingStatement/recordPayment",
  async ({ id, paymentId }) => {
    const response = await axios.post(
      `${API_URL}/billing-statement/${id}/payment`,
      { payment_id: paymentId },
    );
    return response.data;
  },
);

export const sendPaymentReminder = createAsyncThunk(
  "billingStatement/sendReminder",
  async ({ id, reminderType }) => {
    const response = await axios.post(
      `${API_URL}/billing-statement/${id}/reminder`,
      { reminder_type: reminderType },
    );
    return response.data;
  },
);

export const fetchBillingSummary = createAsyncThunk(
  "billingStatement/fetchSummary",
  async (params) => {
    const response = await axios.get(`${API_URL}/billing-statement/summary`, {
      params,
    });
    return response.data;
  },
);
